// extracted by mini-css-extract-plugin
export default {"alert":"alertX6Ck7"};